import { AuthState } from 'models/IAuth';
import { AuthActionTypes, AuthActions } from 'store/auth/types';

const initialState: AuthState = {
  isAuthenticated: false,
  me: null,
  token: localStorage.getItem('token'),
};
export default function (state = initialState, action: AuthActions): AuthState {
  switch (action.type) {
    case AuthActionTypes.LOGIN_WITH_EMAIL_SUCCESS:
    case AuthActionTypes.LOGIN_WITH_OAUTH_SUCCESS:
      localStorage.setItem('token', action.payload.token!);
      return {
        ...state,
        isAuthenticated: true,
        token: action.payload.token,
        me: action.payload.me,
      };
    case AuthActionTypes.LOAD_PROFILE_SUCCESS:
      return {
        ...state,
        isAuthenticated: true,
        me: action.payload.me,
      };
    case AuthActionTypes.LOGOUT_SUCCESS:
    case AuthActionTypes.LOGIN_WITH_EMAIL_FAIL:
      localStorage.removeItem('token');
      return {
        ...state,
        token: null,
        me: null,
        isAuthenticated: false,
      };
    default:
      return state;
  }
}
